// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowSuggestion-cls1__dc93d331bef057ce983d{/*!*/}.BulkFollowSuggestion-cls2___bd9343dac9f69a3ad8d{--size: 46px;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowSuggestion-cls1__dc93d331bef057ce983d",
	"cls2": "BulkFollowSuggestion-cls2___bd9343dac9f69a3ad8d BulkFollowSuggestion-cls1__dc93d331bef057ce983d"
};
export default ___CSS_LOADER_EXPORT___;
